import React from 'react';

import { LinkList } from '@eika/link-list';

import EfakturaAgreement from '../../components/EfakturaAgreement/EfakturaAgreement';
import { Content } from '../../components/shared/Content';
import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';

const EFakturaAgreement: React.FC = () => {
    const { efakturaHistoryLink, efakturaReservationsLink, efakturaArchiveLink, featureToggles } = useConfig();
    const translated = useTranslation();

    return (
        <Content>
            <LinkList className="efaktura-agreement__list-link">
                <EfakturaAgreement />
                {efakturaReservationsLink?.url && (
                    <LinkList.Item href={efakturaReservationsLink.url}>
                        {translated.eFakturaAgreement.reservationsLink}
                    </LinkList.Item>
                )}
                {efakturaHistoryLink && (
                    <LinkList.Item href={efakturaHistoryLink?.url}>
                        {translated.eFakturaAgreement.historyLink}
                    </LinkList.Item>
                )}
                {efakturaArchiveLink && !featureToggles.disableEfakturaHistory && (
                    <LinkList.Item href={efakturaArchiveLink.url}>
                        {translated.eFakturaAgreement.archiveLink}
                    </LinkList.Item>
                )}
            </LinkList>
        </Content>
    );
};

export default EFakturaAgreement;
